import { get } from "../utils/request";
// 接口文档 http://doc.qiwoo.org/doc/view/6209

// 应用安全 -> 安全扫描任务统计信息
export const getTask = (params) => get('/scan/task', params);

// 应用安全 -> 安全扫描统计分析信息
export const getAnalysis = (params) => get('/web/scancompliance/scanSummary', params);

// 应用安全 -> 下载统计数据
export const getDownLoad = (params) => {
    window.open(`
        /web/scancompliance/scanSummaryDown?type=${params.type}&starttime=${params.starttime}&endtime=${params.endtime}
        `);
};
